module.exports = __webpack_public_path__ + "img/reaction11.9408984d.png";